// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown_XFLtt","flag":"index_flag_KSidM","menuIcon":"index_menuIcon_HcOiD"};